function defaultGraph (defaultGraph) {
  return ''
}

module.exports = defaultGraph
